<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
// 关于我们父页面
export default {
  created() {},
};
</script>

<style scoped></style>
